module.exports = __webpack_public_path__ + "img/adminpanel.11a58823.png";